import React, { Fragment, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { fetchData, postData } from '../../../apiService';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import Select from 'react-select';
import '../shared.css';

const StockTransferEcommCreate = () => {
    const history = useHistory();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [confirmRemove, setConfirmRemove] = useState(null);
    const [isValid, setIsValid] = useState(true);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();

    const [selectedBranch, setSelectedBranch] = useState('');
    const [dropdownBranchOptions, setDropdownBranchOptions] = useState([]);
    const [BranchData, setBranchData] = useState([]);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        if (selectedBranch) {
            const b = BranchData.find(x => x.Id == selectedBranch);
            if (b) setFormData(p => ({ ...p, GSTNumber: b.GSTNumber }));
        }
    }, [selectedBranch, BranchData]);

    useEffect(() => {
        fetchData('StockTransferApi', `/BranchEcomm/${companyId}/${branchId}`, token)
            .then(r => { setDropdownBranchOptions(r.response_data); setBranchData(r.response_data); })
            .catch(console.error);
        fetchData('StockTransferApi', `/MaxBillno/${companyId}/${branchId}`, token)
            .then(r => setFormData(p => ({ ...p, BillNumber: r.response_data.BillNumber, BillPrefix: r.response_data.BillPrefix })))
            .catch(console.error);
    }, []);

    const [formData, setFormData] = useState({});
    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const [itemsOptions, setItemsOptions] = useState([]);
    const [itemdetails, setItemDetails] = useState([]);
    const [selectedItems, setSelectedItem] = useState(null);

    const emptyModal = { ItemName: '', ItemId: '', Quantity: '1', Rate: '', Amount: '', HSNCode: '', GSTRate: '', TaxableAmount: '', CGSTAmount: '', SGSTAmount: '', IGSTAmount: '', TotalAmount: '', balanceStock: 0 };
    const [modalData, setModalData] = useState(emptyModal);

    useEffect(() => {
        fetchData('StockTransferApi', `/Item/${companyId}/${branchId}`, token)
            .then(r => {
                if (r.responseCode === '1111') {
                    setItemsOptions(r.response_data.map(i => ({ value: i.Id, label: i.Code + '-' + i.Name })));
                    setItemDetails(r.response_data);
                }
                const d = new Date();
                const today = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
                setFormData(p => ({ ...p, BillDate: today, FromBranchId: branchId, CompanyId: companyId, CreatedBy: userId }));
            }).catch(console.error);
    }, [companyId, branchId, token, userId]);

    const calcGST = (qty, rate, gstrate) => {
        const taxable = (qty * rate).toFixed(2);
        let cgst = 0, sgst = 0, igst = 0;
        if (!formData.GSTNumber) {
            cgst = ((taxable * (gstrate / 2)) / 100).toFixed(2);
            sgst = ((taxable * (gstrate / 2)) / 100).toFixed(2);
        } else {
            const prefix = formData.GSTNumber.toString().substring(0, 2);
            if (prefix !== branchstate) igst = ((taxable * gstrate) / 100).toFixed(2);
            else { cgst = ((taxable * (gstrate / 2)) / 100).toFixed(2); sgst = ((taxable * (gstrate / 2)) / 100).toFixed(2); }
        }
        const total = Math.round((parseFloat(taxable) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));
        return { taxable, cgst, sgst, igst, total };
    };

    const handleItemSelect = (option) => {
        setSelectedItem(option);
        const item = itemdetails.find(i => i.Id === (option ? option.value : ''));
        if (item) {
            const qty = parseFloat(modalData.Quantity) || 0;
            const rate = parseFloat(item.PurchaseRate.toFixed(2)) || 0;
            const gstrate = parseFloat(item.GSTRate.toFixed(2)) || 0;
            const { taxable, cgst, sgst, igst, total } = calcGST(qty, rate, gstrate);
            setModalData({ ...modalData, ItemName: option.label, ItemId: option.value, Rate: rate.toFixed(2), GSTRate: gstrate.toFixed(2), HSNCode: item.HSNCode, Amount: taxable, TaxableAmount: taxable, CGSTAmount: cgst, SGSTAmount: sgst, IGSTAmount: igst, TotalAmount: String(total), balanceStock: item.balanceStock });
        } else {
            setModalData({ ...modalData, ItemName: option ? option.label : '', ItemId: option ? option.value : '', Rate: '0.00', GSTRate: '0', HSNCode: '', balanceStock: 0 });
        }
    };

    const handleModalInputChange = (e) => {
        const qty = parseFloat(e.target.value) || 0;
        setIsValid(qty <= modalData.balanceStock);
        const rate = parseFloat(modalData.Rate) || 0;
        const gstrate = parseFloat(modalData.GSTRate) || 0;
        const { taxable, cgst, sgst, igst, total } = calcGST(qty, rate, gstrate);
        setModalData({ ...modalData, Quantity: qty, Amount: taxable, TaxableAmount: taxable, CGSTAmount: cgst, SGSTAmount: sgst, IGSTAmount: igst, TotalAmount: String(total) });
    };

    const totalCalculation = (items) => {
        const qty = items.reduce((s, i) => s + parseFloat(i.Quantity), 0);
        const taxable = items.reduce((s, i) => s + parseFloat(i.TaxableAmount), 0);
        const cgst = items.reduce((s, i) => s + parseFloat(i.CGSTAmount), 0);
        const sgst = items.reduce((s, i) => s + parseFloat(i.SGSTAmount), 0);
        const igst = items.reduce((s, i) => s + parseFloat(i.IGSTAmount), 0);
        const netAmt = taxable + cgst + sgst + igst;
        const roundOff = Math.round(netAmt) - netAmt;
        const grandTotal = (netAmt + roundOff).toFixed(2);
        setFormData(p => ({ ...p, TotalQuantity: qty, TaxableAmount: taxable.toFixed(2), CGSTAmount: cgst.toFixed(2), SGSTAmount: sgst.toFixed(2), IGSTAmount: igst.toFixed(2), RoundOff: roundOff.toFixed(2), GrandTotal: grandTotal, ModifiedBy: userId }));
    };

    const saveModalData = () => {
        if (!modalData.ItemId) { setErrorMessageModel('Item is required'); return; }
        if (!modalData.Quantity || isNaN(modalData.Quantity)) { setErrorMessageModel('Quantity must be a valid number'); return; }
        if (parseFloat(modalData.Quantity) > modalData.balanceStock) { setErrorMessageModel('Quantity exceeds available stock.'); return; }
        setErrorMessageModel('');
        const updated = [modalData, ...invoicedeatils];
        setInvoicedeatils(updated);
        setModalData(emptyModal);
        setSelectedItem(null);
        totalCalculation(updated);
    };

    const removeRecord = (index) => setConfirmRemove(index);
    const confirmRemoveRecord = () => {
        const updated = [...invoicedeatils];
        updated.splice(confirmRemove, 1);
        setConfirmRemove(null);
        setInvoicedeatils(updated);
        totalCalculation(updated);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(p => ({ ...p, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!selectedBranch) { setErrorMessage('Branch is required!'); setIsLoading(false); return; }
        if (!invoicedeatils.length) { setErrorMessage('Item Details are required!'); setIsLoading(false); return; }
        const payload = { StockTransfer: { ...formData, ModifiedBy: userId, CompanyId: companyId, FromBranchId: branchId,ToBranchId:selectedBranch }, StockTransferDetails: invoicedeatils };
        postData('StockTransferApi', payload, token)
            .then(r => { if (r.response === 'Stock Transfer Create Successfully') history.push(`/StockTransferDetails/${r.kotId}`); })
            .catch(err => { console.error(err); setIsLoading(false); });
    };

    const fmt = (d) => { if (!d) return ''; const dt = new Date(d); return `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,'0')}-${String(dt.getDate()).padStart(2,'0')}`; };

    return (
        <Fragment>
            <div className="pg-container">
                <div className="pg-header">
                    <h5 className="pg-title">Stock Transfer Out (Ecomm) - Create</h5>
                    <div className="pg-header-actions">
                        <div className="pg-action-row">
                            <button className="pg-btn pg-btn-success" onClick={handleSubmit} disabled={isLoading}>
                                <DoneIcon /> {isLoading ? <CircularProgress size={14} color="inherit" /> : 'Save'}
                            </button>
                            <Link to="/Home" className="pg-btn pg-btn-danger"><CloseIcon /> Cancel</Link>
                        </div>
                    </div>
                </div>

                {errorMessage && <div className="pg-alert pg-alert-error">{errorMessage}</div>}

                <div className="pg-card">
                    <div className="pg-hpanel">
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">To Branch <span className="req">*</span></span>
                            <select className="pg-hcell-select" value={selectedBranch}
                                onChange={e => { setSelectedBranch(e.target.value); setFormData(p => ({ ...p, ToBranchId: e.target.value })); }}>
                                <option value="">Select Branch</option>
                                {dropdownBranchOptions.map(b => <option key={b.Id} value={b.Id}>{b.Name}</option>)}
                            </select>
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Bill Date</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="date" value={fmt(formData.BillDate)} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Bill Number</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text" value={formData.BillNumber || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 90px' }}>
                            <span className="pg-hcell-label">Total Qty</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text" value={formData.TotalQuantity || ''} readOnly />
                        </div>
                    </div>

                    <div className="pg-item-bar" style={{ marginTop: 12 }}>
                        {errorMessageModel && <div className="pg-alert pg-alert-error" style={{ width: '100%', marginBottom: 0 }}>{errorMessageModel}</div>}
                        <div className="pg-field" style={{ flex: '3 1 200px' }}>
                            <label className="pg-label">Item Name</label>
                            <div style={{ marginTop: 6 }}>
                                <Select value={selectedItems} onChange={handleItemSelect} options={itemsOptions}
                                    placeholder="Select item..." isSearchable menuPortalTarget={document.body} menuPosition="fixed"
                                    styles={{ control: b => ({ ...b, minHeight: 31, height: 31, fontSize: 12.5, borderColor: 'rgba(200,212,224,0.7)', borderRadius: 6 }), valueContainer: b => ({ ...b, padding: '0 10px' }), indicatorsContainer: b => ({ ...b, height: 31 }), menuPortal: b => ({ ...b, zIndex: 9999 }) }} />
                            </div>
                        </div>
                        <div className="pg-field narrow">
                            <label className="pg-label">Quantity</label>
                            <input className={`pg-input text-right${!isValid ? ' cash-negative' : ''}`} type="number" placeholder="Qty" value={modalData.Quantity} onChange={handleModalInputChange} min={1} max={modalData.balanceStock} />
                        </div>
                        {modalData.balanceStock > 0 && <div style={{ display: 'flex', alignItems: 'flex-end', fontSize: 11, color: '#64748b', paddingBottom: 4 }}>Stock: {modalData.balanceStock}</div>}
                        <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                            <button className="pg-btn pg-btn-success" onClick={saveModalData}><AddIcon /> Add</button>
                        </div>
                    </div>

                    <div className="pg-invoice-table-wrap" style={{ marginTop: 12 }}>
                        <table className="pg-invoice-table">
                            <thead><tr><th>#</th><th>Item Name</th><th className="right">Qty</th><th className="right">Rate</th><th className="right">Amount</th><th className="right">Action</th></tr></thead>
                            <tbody>
                                {invoicedeatils.length === 0
                                    ? <tr><td colSpan={6} style={{ textAlign: 'center', color: '#94a3b8', padding: 14 }}>No items added yet.</td></tr>
                                    : invoicedeatils.map((item, i) => (
                                        <tr key={i}>
                                            <td style={{ textAlign: 'center', width: 40 }}>{i + 1}</td>
                                            <td>{item.ItemName}</td>
                                            <td className="right">{item.Quantity}</td>
                                            <td className="right">{item.Rate}</td>
                                            <td className="right" style={{ fontWeight: 700 }}>{item.TotalAmount}</td>
                                            <td className="right"><IconButton size="small" onClick={() => removeRecord(i)}><DeleteIcon style={{ fontSize: 16, color: '#dc2626' }} /></IconButton></td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="pg-hpanel" style={{ marginTop: 8 }}>
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">Remarks</span>
                            <input className="pg-hcell-input" type="text" placeholder="Remarks" name="Remarks" value={formData.Remarks || ''} onChange={handleChange} />
                        </div>
                        {[['Amount', 'TaxableAmount'], ['CGST', 'CGSTAmount'], ['SGST', 'SGSTAmount'], ['IGST', 'IGSTAmount'], ['Round Off', 'RoundOff'], ['Grand Total', 'GrandTotal']].map(([label, key]) => (
                            <div key={key} className="pg-hcell" style={{ flex: '1 1 0' }}>
                                <span className="pg-hcell-label">{label}</span>
                                <input className="pg-hcell-input pg-hcell-readonly text-right" type="text" value={formData[key] || ''} readOnly />
                            </div>
                        ))}
                    </div>
                </div>

                {confirmRemove !== null && (
                    <div className="pg-modal-backdrop" onClick={() => setConfirmRemove(null)}>
                        <div className="pg-modal-card" onClick={e => e.stopPropagation()}>
                            <div className="pg-modal-icon-wrap"><WarningAmberIcon className="pg-modal-icon" /></div>
                            <h6 className="pg-modal-title">Remove Item?</h6>
                            <p className="pg-modal-body">This item will be removed from the invoice. This action cannot be undone.</p>
                            <div className="pg-modal-actions">
                                <button className="pg-modal-btn pg-modal-btn-cancel" onClick={() => setConfirmRemove(null)}>Cancel</button>
                                <button className="pg-modal-btn pg-modal-btn-confirm" onClick={confirmRemoveRecord}><DeleteIcon style={{ fontSize: 15 }} /> Yes, Remove</button>
                            </div>
                        </div>
                    </div>
                )}

                <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>
            </div>
        </Fragment>
    );
};

export default StockTransferEcommCreate;
